import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, EmailSyncDetails} from '../types'

type Variables = {plantCode: string; storageId: number; dto: EmailSyncDetails}

export const useAddStorageEmailParserConnection = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, storageId, dto}) => {
      const response = await ApiClient.axiosInstance.post<MaterialStorage>(
        `/plants/${plantCode}/material-storage/${storageId}/details/email-parser`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
